/**
 * @generated SignedSource<<ba395277b7a85a77ff8fb2ab15876ae0>>
 * @relayHash 726449f2caaf318fb24fd8bb1f8076fd
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 726449f2caaf318fb24fd8bb1f8076fd

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contractId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contractId",
        "variableName": "contractId"
      },
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "concreteType": "GenerateManagerFileStatusMutationResponse",
    "kind": "LinkedField",
    "name": "sendForSignatureStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusError",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SendForSignatureStatusMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SendForSignatureStatusMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "726449f2caaf318fb24fd8bb1f8076fd",
    "metadata": {},
    "name": "SendForSignatureStatusMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "a8b8c4e7aa61d9c2b849c9ccc51ffbd8";

export default node;
